import SeeMore from "../../../shared/SeeMore";

const InfoTwoFactor = ({ mainMessage }) => {
	return (
		<SeeMore>
			<strong>Por que precisamos desses dados?</strong>

			<p>{mainMessage}</p>
			<strong>Seus dados estão seguros</strong>
			<p>
				Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em
				segurança. Aqui, seus dados estão protegidos.
			</p>
		</SeeMore>
	);
};

export default InfoTwoFactor;
